// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GraphEmptyState__emptyState___1m81Z{align-items:center;display:flex;justify-content:center;left:280px;margin-left:20px;position:absolute;top:55px;pointer-events:none}.GraphEmptyState__emptyStateIcon___19zzF{height:128px;margin-bottom:24px;width:128px}.GraphEmptyState__emptyStateText___B5K84{font-family:'Roboto', serif;font-weight:400;line-height:1.5;margin-left:-20px;margin-top:20px;max-width:320px;opacity:0.7;text-align:center;user-select:none}.GraphEmptyState__emptyStateText___B5K84 strong{font-size:18px;font-weight:700}\n", ""]);
// Exports
exports.locals = {
	"emptyState": "GraphEmptyState__emptyState___1m81Z",
	"emptyStateIcon": "GraphEmptyState__emptyStateIcon___19zzF",
	"emptyStateText": "GraphEmptyState__emptyStateText___B5K84"
};
module.exports = exports;
